import { render, staticRenderFns } from "./infoModal.vue?vue&type=template&id=623fd3c0&scoped=true&"
import script from "./infoModal.vue?vue&type=script&lang=js&"
export * from "./infoModal.vue?vue&type=script&lang=js&"
import style0 from "./infoModal.vue?vue&type=style&index=0&id=623fd3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fd3c0",
  null
  
)

export default component.exports